import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { PropertySearchResponse, PropertyDetails } from './property-search.type';
import { RealEstateFilter } from '@app-model/realEstate';
import { PageControl } from '@app-model/page-control';
import { AvailableIntegration } from '@app-model/integration';

interface PageControlInterface {
	page: number;
	pageSize: number;
}

@Injectable({
	providedIn: 'root'
})
export class PropertySearchService {
	constructor(private http: HttpClient) {}

	searchProperties(filter: RealEstateFilter, pageControl: PageControl): Observable<PropertySearchResponse> {
		const pageControlInterface: PageControlInterface = {
			page: Number(pageControl?.page ?? 0),
			pageSize: Number(pageControl?.limit ?? pageControl?.pageSize ?? 20)
		};

		const params = this.buildParams(filter, pageControlInterface);

		return this.http.get<PropertySearchResponse>(`${environment.api}/search-properties/list`, { params });
	}

	private buildParams(filter: RealEstateFilter, pageControl: PageControlInterface): HttpParams {
		let params = new HttpParams();

		Object.entries(filter).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				if (Array.isArray(value)) {
					value.forEach(item => {
						params = params.append(`${key}`, item.toString());
					});
				} else {
					params = params.append(`${key}`, value.toString());
				}
			}
		});

		Object.entries(pageControl).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				params = params.append(`${key}`, value.toString());
			}
		});

		return params;
	}

	getPropertyById(id: string): Observable<PropertyDetails> {
		return this.http.get<PropertyDetails>(`${environment.api}/search-properties/${id}`);
	}

	getAvailableIntegrations(): Observable<AvailableIntegration[]> {
		return this.http.get<AvailableIntegration[]>(`${environment.api}/search-properties/available-integrations`);
	}
}
